import {
	HttpHandlerFn,
	HttpInterceptorFn,
	HttpRequest,
} from '@angular/common/http';
import { tap } from 'rxjs/operators';

export interface PerformanceTrackingInterceptorEvent {
	started: Date;
	method: string;
	url: string;
	elapsed: number;
	params: string;
	body: string;
	result: 'success' | 'error';
}

export const performanceTrackingInterceptorStore = {
	events: [] as PerformanceTrackingInterceptorEvent[],
};

const bannedUrls = ['/log-store', '/page-view', '/login_status'];

export const withPerformanceTrackingInterceptor: HttpInterceptorFn = (
	req: HttpRequest<unknown>,
	next: HttpHandlerFn,
) => {
	if (bannedUrls.some((url) => req.url.includes(url))) {
		return next(req);
	}

	const started = new Date();
	const startedPerf = performance.now();
	return next(req).pipe(
		tap({
			next: (event) => {
				if (event.type === 4) {
					performanceTrackingInterceptorStore.events.push({
						started,
						method: req.method,
						url: req.url,
						elapsed: performance.now() - startedPerf,
						params: req.params.toString(),
						body: req.body ? JSON.stringify(req.body) : '',
						result: 'success',
					});
				}
			},
			error: () => {
				performanceTrackingInterceptorStore.events.push({
					started,
					method: req.method,
					url: req.url,
					elapsed: performance.now() - startedPerf,
					params: req.params.toString(),
					body: req.body ? JSON.stringify(req.body) : '',
					result: 'error',
				});
			},
		}),
	);
};
